//@flow

import {Divider, List, Typography, makeStyles} from '@material-ui/core';
import React, {createContext} from 'react';
import {useSidebarContext} from './SidebarContainer';

type Props = {
  children: React$Node,
  header?: React$Node | string,
};

const useStyles = makeStyles(theme => ({
  wrapperTitleResources: {
    padding: '.75rem 1rem',
  },
  titleResources: {
    fontSize: '12px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#9595AB',
  },
  sidebarList: {
    width: '100%',
    padding: '.5rem',
    '&[data-shrink="true"]': {
      padding: '.75rem 0',
    },
  },
}));

type ContextProps = {
  openItem: string,
  setOpenItem: (value: string) => void,
};

const SidebarContext = createContext<ContextProps | null>(null);

export function useSidebarSectionContext(): ContextProps {
  const context = React.useContext(SidebarContext);

  if (!context) {
    throw new Error(
      'useSidebarSectionContext must be used within a SidebarSectionContextProvider'
    );
  }

  return context;
}

export default function SidebarSection({children, header}: Props) {
  const classes = useStyles();

  const isLabel = typeof header === 'string';

  const {shrink} = useSidebarContext();
  const [openItem, setOpenItem] = React.useState('');

  const toggleOpenItem = (value: string) => {
    setOpenItem(openItem === value ? '' : value);
  };

  return (
    <div className={classes.root}>
      {shrink ? (
        <Divider />
      ) : (
        <div className={classes.wrapperTitleResources}>
          {isLabel ? (
            <Typography className={classes.titleResources}>{header}</Typography>
          ) : (
            header
          )}
        </div>
      )}
      <SidebarContext.Provider value={{openItem, setOpenItem: toggleOpenItem}}>
        <List className={classes.sidebarList} data-shrink={shrink}>
          {children}
        </List>
      </SidebarContext.Provider>
    </div>
  );
}
